import { render, staticRenderFns } from "./TriggerDelete.vue?vue&type=template&id=2e1b495a&scoped=true&"
import script from "./TriggerDelete.vue?vue&type=script&lang=js&"
export * from "./TriggerDelete.vue?vue&type=script&lang=js&"
import style0 from "./TriggerDelete.vue?vue&type=style&index=0&id=2e1b495a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b495a",
  null
  
)

export default component.exports